import {defineStore} from "pinia";
import {deserialize, serialize} from "jsonapi-fractal";
import FormQuestionTypeAPI from "@/api/FormQuestionTypeAPI";

export const useFormQuestionTypeStore = defineStore('form-question-type', {
  state: () => ({
    data: [],
  }),
  actions: {
    clear() {
      this.data = [];
    },
    find(id) {
      return this.data.find(data => parseInt(data.id) === parseInt(id)) || null;
    },
    index(payload) {
      const { params } = payload;

      return new FormQuestionTypeAPI().index(params)
      .then((response) => {
        this.data = response.data;
        return response;
      });
    },
  },
  persist: true,
});
